import { format as dateFormat } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { pl } from 'date-fns/locale/pl';
import i18n from 'i18next';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  date: Date;
  format: string;
}

export const FormatDate: FC<Props> = ({ date, format }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'pl' ? pl : enUS;

  return <>{dateFormat(date, format, { locale: locale })}</>;
};

export const formatDate = (date: Date, format: string) => {
  const locale = i18n.language === 'pl' ? pl : enUS;

  return dateFormat(date, format, {
    locale: locale,
  });
};
